// Load jsPDF library
const script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
script.async = true;
script.onload = function() {
  console.log('jsPDF library loaded successfully');
  window.jspdf = window.jspdf || {};
  window.jspdf.jsPDF = window.jspdf.jsPDF || window.jspdf;
};
script.onerror = function() {
  console.error('Failed to load jsPDF library');
};
document.head.appendChild(script); 